var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.81.867 2.676 4.635h2.853V7.17h-.973l-.63 7.57a.833.833 0 0 1-.83.763h-11.8a.833.833 0 0 1-.831-.764l-.631-7.57-.972.001V5.502h2.852L6.2.867l1.444.834-2.195 3.801h7.112l-2.194-3.801zm2.884 6.302H3.316l.556 6.667h10.266zM9.839 8.836v3.333H8.172V8.836zm-3.334 0v3.333H4.84V8.836zm6.667 0v3.333h-1.667V8.836z"
  })));
};
export default SvgBasket;